const inViewport = function(el, {
  inside,
  outside,
  threshold = 1
} = {}, thisArg) {
  if(window.IntersectionObserver){
    let inViewport = false;

    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        console.log(entry);
        if(entry.intersectionRatio != threshold){
          inViewport = false

          if (typeof outside === 'function') { outside.call(thisArg) }
        } else if(!inViewport) {
          inViewport = true

          if (typeof inside === 'function') { inside.call(thisArg) }
        }
      });
    }, {threshold: threshold});

    observer.observe(el);
  }
};

export default inViewport;
